export interface PageNotification {
    id: string;
    lastChange: string;
    type: PageNotificationType;
    closable: boolean;
    locations: PageNotificationLocation[];
    content: string;
}

export enum PageNotificationLocation {
    BROKER_DASHBOARD = 'BROKER_DASHBOARD',
    BROKER_TRADE = 'BROKER_TRADE',
    EXCHANGE_DASBOARD = 'EXCHANGE_DASBOARD',
    FIAT_DEPOSIT = 'FIAT_DEPOSIT',
    FIAT_WITHDRAWAL = 'FIAT_WITHDRAWAL',
    LIMITS = 'LIMITS',
    VERIFICATION = 'VERIFICATION',
    FEES = 'FEES',
    SUPPORT = 'SUPPORT',
    SETTINGS = 'SETTINGS'
}

export enum PageNotificationType {
    INFO = 'INFO',
    ALERT = 'ALERT',
    IMPORTANT = 'IMPORTANT'
}
